import React, { useState } from "react";
import ImageModal from "./ImageModal";
import "./ProductCard.css";

const ProductCard = ({ product, searchTerm }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const openImageModal = () => {
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  return (
    <>
      <div className="product-card">
        <div className="product-header" onClick={toggleExpanded}>
          <img
            src={product.image}
            alt={product.name}
            className="product-image clickable"
            onClick={(e) => {
              e.stopPropagation();
              openImageModal();
            }}
            onError={(e) => {
              e.target.src =
                "https://via.placeholder.com/300x200?text=Product+Image";
            }}
          />
          <div className="product-info">
            <h4 className="product-name">{product.name}</h4>
            {product.company && (
              <p className="product-company">ផលិតដោយ: {product.company}</p>
            )}
            {product.description && (
              <p className="product-description">{product.description}</p>
            )}
            {product.source && (
              <div className="product-source">
                <span className="source-label">ប្រភព:</span>
                <a
                  href={product.source}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="source-link"
                >
                  {product.source_label}
                </a>
              </div>
            )}
            {product.alternatives && (
              <span className="alternatives-count">
                {product.alternatives.length} ជម្រើសផ្សេងទៅវិញ
              </span>
            )}
          </div>
          <button className="expand-button small">
            {isExpanded ? "−" : "+"}
          </button>
        </div>

        {isExpanded && (
          <div className="product-content">
            <h5>ផលិតផលជម្រើសផ្សេងទៅវិញ</h5>
            <div className="alternatives-grid">
              {product.alternatives &&
                product.alternatives.map((alternative) => (
                  <div key={alternative.id} className="alternative-item">
                    <img
                      src={alternative.image}
                      alt={alternative.name}
                      className="alternative-image clickable"
                      onClick={() => {
                        // Open modal for alternative product image
                        setIsImageModalOpen(true);
                      }}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/200x150?text=Alternative";
                      }}
                    />
                    <p className="alternative-name">{alternative.name}</p>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>

      {/* Image Modal */}
      <ImageModal
        isOpen={isImageModalOpen}
        image={product.image}
        title={product.name}
        onClose={closeImageModal}
      />
    </>
  );
};

export default ProductCard;
